import WorkbenchInterface from '../common/WorkbenchInterface'
import definitionSerializer from '@/appComponents/workbench/targetDefinition/services/serializer'
import { convertViewingStreamForAM, convertViewingStreamForES } from '@/appLogic/targets/conversions'
import { fetchTargetData, fetchTargetDefinition, saveTarget } from '@/api'
import {
  INCREMENT_REQUEST_NUMBER,
  SET_INTERFACE,
  STORE_NAME,
  SET_TARGET_DATA,
  SET_LOADING,
  RESET,
  SET_VIEWING_STREAM,
} from './store/actions'
import {
  SET_ENABLE_DOWN_STREAM,
  SET_ENABLE_DEFINITION_ACTIONS,
  SET_ENABLE_SAVE_BUTTON,
  SET_SLOTTED_VALUE,
  SET_TARGET,
} from '../common/store/actions'
import { SET_DROPPED_ATTRIBUTES_IN_TD } from '@/appComponents/workbench/targetDefinition/store/actions'
import LasStore from './store'
import DateStore, {
  STORE_NAME as DATE_STORE_NAME,
} from '@/appComponents/workbench/lasGraphs/viewership/dateRange/store'
import {
  INIT_DATE_RANGE,
  UPDATE_START_DATE,
} from '@/appComponents/workbench/lasGraphs/viewership/dateRange/store/actions'
import { ACTIVATION_STATUS, TARGET_TYPES_INTEGERS, TARGET_TYPE, VIEWING_STREAMS } from '@/appLogic/targets/Constants'
import store, { registerIfNotExist } from '@/store'

class LASInterface extends WorkbenchInterface {
  /**
   * This should pass the interface to the current store, so that the other store
   * can communicate with this interface
   * @param {*} context - this is the VueX context object
   */
  async setInterface(context) {
    // NOTE: current behavior relies on dispatch promises not being awaited, otherwise 'context.rootGetters.startDate'
    // is not set in time for DateRange component render (tldr: things will break if you await the dispatches below)
    context.dispatch(SET_INTERFACE, this)
    registerIfNotExist(['DateRange'], DateStore)
    console.log('calling init action')
    const { dateRanges, minStartMonths } = context.rootState.appRes
    store.dispatch(INIT_DATE_RANGE, dateRanges, minStartMonths.amrld)
    // Set default viewing stream
    context.dispatch(SET_VIEWING_STREAM, convertViewingStreamForES(VIEWING_STREAMS.C3))
    // if (context.rootState.workbench.workbenchTarget && context.rootState.workbench.workbenchTarget.viewing_stream) {
    //   context.dispatch(SET_VIEWING_STREAM, convertViewingStreamForES(context.rootState.workbench.workbenchTarget.viewing_stream))
    // }
    // set the dates
    return new Promise((resolve, reject) => {
      resolve()
    })
  }

  saveTarget(targetInfo) {
    const getters = targetInfo.context.getters
    const context = targetInfo.context
    // TODO_AFTER implement rhpm and revision history later
    const rhpm = getters.revisionHistoryCurrentMove
    const lasState = context.state.las_workbench
    // TODO_AFTER not sure about the 'target' variable, m
    // have to ensure that it will work with the current state
    const target = targetInfo.target
    const query = targetInfo.targetDefinition
    const broadcastQuarter = targetInfo.target.target_definition.broadcastQuarter
    const rootGetters = context.rootGetters
    let targetDefinition = {
      query,
      startDate: rootGetters.startDate.from,
      endDate: rootGetters.endDate.to,
      viewSource: lasState.viewingSource,
      networks: lasState.selectedViewershipNetworks,
    }
    if (broadcastQuarter) {
      targetDefinition = {
        ...targetDefinition,
        broadcastQuarter: broadcastQuarter,
      }
    }
    let tAndTd = super.getTargetAndDatasourceInformation(query)
    let dataToSave = {
      id: target.id,
      username: target.username,
      display_name: target.display_name,
      target: target.target || TARGET_TYPE.LAS,
      target_type: target.target_type || TARGET_TYPES_INTEGERS.LAS,
      target_datasource: target.target_datasource,
      target_definition: targetDefinition,
      viewing_stream: convertViewingStreamForAM(lasState.viewingSource),
      networks: lasState.selectedViewershipNetworks, // NETWORK
      audience_size: lasState.audienceSize,
      universe: lasState.universe,
      metrics: lasState.metrics,
      viewership_historical: lasState.hisoricalViewership,
      advertiser: target.advertiser ? target.advertiser : context.state.workbenchTarget.advertiser,
      destinations: target.destinations && target.destinations.length > 0 ? target.destinations : [],
      metadata: target.metadata,
      ...tAndTd,
    }
    // TODO reduce the payload to the lambda by reducing reusing the workbench_data object
    // and the fields that it contains.
    if (rhpm) {
      // TODO Revision History should include the Networks
      // add data from the last step here...
      const td = rhpm.target_data
      dataToSave = {
        age_data: td.age,
        income_data: td.income,
      }
    }
    // this is a messed up hacky way to do it, but it works for now
    const workbenchDataValues = [
      'income_data',
      'age_data',
      'viewership_historical',
      'metrics',
      'universe',
      'audience_size',
      'social_affinity',
      'tsp_attributes',
      'activation_path',
      'brand_reach',
      'networks',
      'activation_path',
    ]
    const workbenchData = {}
    for (const key in dataToSave) {
      if (workbenchDataValues.includes(key)) {
        workbenchData[key] = dataToSave[key]
      }
    }
    dataToSave.workbench_data = workbenchData
    if (
      !dataToSave.activation_status ||
      (dataToSave.activation_status && dataToSave.activation_status === ACTIVATION_STATUS.DRAFT)
    ) {
      dataToSave.activation_status = ACTIVATION_STATUS.WORKING
    }
    return saveTarget(dataToSave).then(res => {
      if (res && res.data) {
        context.commit(SET_TARGET, res.data)
      }
      // TODO Might want to do something here
      // set the current targets target Definition here...
      // will have to set the appropriate values here
      context.commit(SET_LOADING, false)
      context.commit(SET_ENABLE_SAVE_BUTTON, false)
      // I am not sure about this one
      // context.dispatch(SET_CURRENT_TARGET, res.data)
      // I do not think the following need to occur in the new workbench program
      // context.dispatch(SET_CURRENT_TARGET_DEFINITION, getters.targetDefinition)
    })
    // TODO_AFTER looks like we have to make the save button work
    // Not sure if we are going to do anything around that
    // whatever is the save target information....
    // save graph information
    // save the history information
    // not sure what else is going on here..
  }

  async onTargetDefinitionChange({ targetDefinition, initialLoad, context }) {
    // set new start date here if contains mri/ncs
    const datasources = new Set(
      targetDefinition
        .flat(Infinity)
        .filter(n => n.dataset)
        .map(n => n.dataset),
    )
    const dis = context.dispatch
    const getter = context.rootGetters
    const { minStartMonths, maxEndMonths } = context.rootState.appRes
    const workbenchTarget = context.rootState.workbench.workbenchTarget

    let startDate = getter.startDate || minStartMonths.amrld
    let endDate = getter.endDate || maxEndMonths.amrld
    // TODO: skip start date update if no change is necessary
    if (datasources.has('mri') && datasources.has('ncs')) {
      if (minStartMonths.mri.from > minStartMonths.ncs.from) {
        if (startDate.from > minStartMonths.ncs.from) {
          startDate = minStartMonths.ncs
          await store.dispatch(UPDATE_START_DATE, startDate.from)
        }
      } else {
        if (startDate.from > minStartMonths.mri.from) {
          startDate = minStartMonths.mri
          await store.dispatch(UPDATE_START_DATE, startDate.from)
        }
      }
    } else if (datasources.has('mri') && startDate.from > minStartMonths.mri.from) {
      startDate = minStartMonths.mri
      await store.dispatch(UPDATE_START_DATE, startDate.from)
    } else if (datasources.has('ncs') && startDate.from > minStartMonths.ncs.from) {
      startDate = minStartMonths.ncs
      await store.dispatch(UPDATE_START_DATE, startDate.from)
    } else {
      await store.dispatch(UPDATE_START_DATE, startDate.from)
    }

    // TODO_AFTER may have lost the Drop attribute feature for LAS targets...
    dis(SET_LOADING, true)
    dis(SET_ENABLE_SAVE_BUTTON, false)
    dis(SET_ENABLE_DOWN_STREAM, false)
    dis(SET_ENABLE_DEFINITION_ACTIONS, false)
    context.commit(INCREMENT_REQUEST_NUMBER)
    // SET_DROPPED_ATTRIBUTES_IN_TD should be somewhere we can access it
    let s = context.rootState.workbench.las_workbench
    let networks = context.rootState.networks.networks
    let data = {
      query: targetDefinition,
      startDate: startDate.from,
      endDate: endDate.to,
      networks: s.selectedViewershipNetworks,
      viewSource: s.viewingSource,
    }
    const currentRequestId = s.requestNumber
    const freshTargetDefinition = fetchTargetDefinition(data).then(resp => {
      // set new target definition here
      const freshDefinition = resp.data
      if (currentRequestId === s.requestNumber) {
        // seems to be dropping all the attributes some how
        context.commit(SET_DROPPED_ATTRIBUTES_IN_TD, definitionSerializer.deserialize(freshDefinition))
      }
      // TODO_AFTER looks like there is more to this than just the newTargetDefinition
      // what is the  getters.targetDefinition for the LAS Store
      return context.getters.newTargetDefinition
    })

    // fetchTargetData will need several more definitions defined in the signature of the call
    //  query, startDate, endDate, networks, viewSource
    // we are going to need to get the startDate endDate networks and viewSource all of these things come from the store of the LAS
    const targetData = fetchTargetData(data).then(resp => {
      const targetData = {
        metrics: resp.metrics,
        networks: networks,
        audienceSize: resp.audienceSize && resp.audienceSize.audience,
        historicalViewership: resp.historicalViewership,
        universe: resp.universe,
      }
      return targetData
    })
    Promise.all([freshTargetDefinition, targetData])
      .then(resp => {
        const ftd = resp[0] // freshTargetDefinition
        // TODO_AFTER need to implement the new target definition
        const td = resp[1] // targetData
        let audienceSize
        if (
          initialLoad &&
          workbenchTarget.audience_size &&
          workbenchTarget.activation_status === ACTIVATION_STATUS.LIVE
        ) {
          // Audience Size was already updated with Foresite Target Population value. Use it for displaying Target Audience in Workbench
          audienceSize = Number(workbenchTarget.audience_size)
        } else {
          // Use Audience Size value from 12 month aggregate ES calculation
          audienceSize = td.audienceSize
        }
        context.dispatch(SET_TARGET_DATA, td)
        dis(SET_ENABLE_SAVE_BUTTON, !initialLoad)
        // construct the slotted value, I believe it is the targetData
        context.commit(SET_SLOTTED_VALUE, {
          viewershipData: td.historicalViewership,
          networks: networks,
          dayPartsConfig: context.rootState.app,
          audienceSize: audienceSize,
          universeData: td.universe,
          lasState: s,
        })
      })
      .catch(resp => {
        // might want to set the value of the slotted value to nothing
        // or display something that makes the users awear of the fact that the api failed
      })
      .finally(fin => {
        // TODO stop loading for the container
        let wbTarget = context.rootState.workbench.workbenchTarget
        if (
          wbTarget &&
          wbTarget.activation_status === 'WORKING' &&
          context.getters.newTargetDefinition &&
          context.getters.newTargetDefinition.length > 0
        ) {
          dis(SET_ENABLE_DOWN_STREAM, initialLoad)
        } else {
          dis(SET_ENABLE_DOWN_STREAM, false)
        }
        dis(SET_ENABLE_DEFINITION_ACTIONS, true)
        dis(SET_LOADING, false)
      })
    // TODO_AFTER add in the history API calls
    // this could also update the history stuff as well
    // will do queryForData()
  }

  getTargetDefinition(getters) {
    // TODO_AFTER not sure if this is what i need to be looking at for the freshTargetDefinition
    return getters.serializedDefinition
  }

  onSetTarget(targetInfo, context) {
    // use the context and the targetInformation to set the target
    // things like setting the query, things about the target
    // setting the slotted value
    // enabling things based off the value of the target
    // enabling the definitions actions
    console.log('Not Implemented')
  }

  reset(context) {
    context.dispatch(RESET)
  }

  submitDownstream(targetInfo) {
    // DO NOT IMPLEMENT YET
    // Not sure how this is different than sendDownStream()
    // Will leave for when we know more information on what is to happen to the target once we have created
    // the target definition and are ready to move forward with the target
    throw Error('Not Implemented')
  }

  sendDownStream() {
    // DO NOT IMPLEMENT YET
    throw Error('Not Implemented')
  }

  /**
   * @returns [{name, module}, ......]
   */
  getStoreModules() {
    return [
      {
        name: STORE_NAME,
        module: LasStore,
      },
    ]
  }

  getDefaultTarget(targetInfo) {
    // just return a default target
    return {}
  }

  /**
   * When there is a duplicate on create
   */
  onDuplicate() {
    // Any actions that should occur when a duplication has occured
    throw Error('Not Implemented')
  }

  /**
   * When the view is created
   */
  onCreate() {
    // any operations to occur when the view is created
    throw Error('Not Implemented')
  }

  modelLAL() {
    throw Error('Not Implemented')
  }

  onSetAdvertiser() {
    // Anything that occurs when the advertiser has been set
    // No Action needed for LAS
  }
}

/*
 * TODO need to have the following occur
 *  1. we need to call the following when the definition changes
 *    a. the universe
 *    b. the monnthly count
 *    c. the demographics
 *    d. the secondary networks table information
 *  2. we will be providing the default for the following
 *   a. the start date
 *   b. the end date
 *   c. the networks
 *   d.
 */

// if (getters.isFetchingTarget) return
// commit(SET_LOADING, true)
// commit(SET_FETCHING_TARGET, true)

// const targetDefinitionToFetch = getters.targetDefinition
// const ageAndIncome = dispatch(SET_DATA_FOR_AGE_AND_INCOME_GRAPHS)
// .then(ageAndIncome => {
//   return Bluebird.props({
//     age: ageAndIncome.age,
//     income: ageAndIncome.income
//   })
// })

// const freshTargetDefinition = fetchTargetDefinition(targetDefinitionToFetch).then(resp => {
//   // set new target definition here
//   const freshDefinition = resp.data
//   commit(SET_DEFINITION, definitionSerializer.deserialize(freshDefinition))
//   return getters.targetDefinition
// })
// // TODO why do we need to make seperate calls here?
// // combine these calls here.
// const targetData = fetchTargetData(targetDefinitionToFetch).then(resp => {
//   const targetData = {
//     metrics: resp.metrics,
//     audienceSize: resp.audienceSize && resp.audienceSize.audience,
//     historicalViewership: resp.historicalViewership,
//     universe: resp.universe
//   }
//   return targetData
// })
// return Bluebird.props({
//   ageAndIncome,
//   freshTargetDefinition,
//   targetData
// }).then(targetInformation => {
//   if (targetInformation.freshTargetDefinition !== getters.targetDefinition) {
//     commit(SET_FETCHING_TARGET, false)
//     dispatch(FETCH_DATA_FROM_TARGET_FOR_GRAPHS)
//     return null
//   } else {
//     dispatch(SET_DATA_FROM_TARGET, targetInformation.targetData)
//     const lastMove = getters.targetDefinitionLastAttributeCommand
//     const userHasMadeAForwardAction = lastMove
//     if (userHasMadeAForwardAction) {
//       // TODO add the label based off the lastMove
//       dispatch(FORWARD_REVISION_HISTORY, {
//         targetData: {
//           ...targetInformation.targetData,
//           ...targetInformation.ageAndIncome
//         },
//         targetDefinition: targetInformation.freshTargetDefinition,
//         audience: targetInformation.targetData.audienceSize,
//         label: generateLabel(lastMove)
//       })
//     }
//     commit(SET_LOADING, false)
//     commit(SET_FETCHING_TARGET, false)
//   }

export default LASInterface



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/LAS/LASInterface.js